import { ApiClient } from './api-client';
import type { ApiResponse } from '../types';

export interface AvailabilitySlot {
  id: string;
  /** ISO-8601 UTC instant. */
  startsAt: string;
  durationMinutes: number;
  booked: boolean;
}

export interface SlotInput {
  startsAt: string;
  durationMinutes?: number;
}

export const availabilityService = {
  /** Public — returns only free slots. */
  listForProvider: (
    providerId: string,
    fromIso: string,
    toIso: string,
  ): Promise<ApiResponse<AvailabilitySlot[]>> =>
    ApiClient.get<AvailabilitySlot[], { from: string; to: string }>(
      `/providers/${providerId}/availability`,
      { from: fromIso, to: toIso },
    ),

  /** Authenticated provider — returns every slot (free + booked). */
  listMine: (
    fromIso: string,
    toIso: string,
  ): Promise<ApiResponse<AvailabilitySlot[]>> =>
    ApiClient.get<AvailabilitySlot[], { from: string; to: string }>(
      '/providers/me/availability',
      { from: fromIso, to: toIso },
    ),

  createMany: async (slots: SlotInput[]): Promise<AvailabilitySlot[]> =>
    (await ApiClient.post<AvailabilitySlot[]>(
      '/providers/me/availability',
      { slots },
    )).data,

  delete: async (slotId: string): Promise<void> => {
    await ApiClient.delete(`/providers/me/availability/${slotId}`);
  },
};
